import * as api from '../../../api/auth'
import { SIGN_IN, SIGN_UP } from '../../actionTypes'
import { setAlert } from '../alert/setAlert'
import { hideLoader } from './../loader/hideLoader'
import { showLoader } from './../loader/showLoader'
import { verifyToken } from './verifyToken'
import { setIsReady } from './../app/setIsReady'

export const signUp = (formData, clear, setIsSignUp) => async (dispatch) => {
  try {
    dispatch(showLoader())
    const { data } = await api.signUp(formData)
    dispatch({ type: SIGN_UP, payload: data })
    dispatch(setAlert(true, 'success', data.message))
    setIsSignUp((prev) => !prev)
    clear()
    dispatch(hideLoader())
  } catch (e) {
    dispatch(hideLoader())
    const errorMessages = e.response.data
    if (errorMessages.errorsArray) {
      const allMsg = errorMessages.errorsArray.map((e) => e.msg)
      return dispatch(setAlert(true, 'error', allMsg.join(', ')))
    }
    return dispatch(setAlert(true, 'error', errorMessages.message))
  }
}

export const signIn = ({ email, password }, clear) => async (dispatch) => {
  try {
    dispatch(showLoader())
    const { data } = await api.signIn({ email, password })
    localStorage.setItem('token', JSON.stringify(data.token))
    dispatch({ type: SIGN_IN, payload: data })
    dispatch(setAlert(true, 'success', 'Login, successfull', 2000))
    clear()
  } catch (e) {
    dispatch(hideLoader())
    const errorMessages = e.response.data
    if (errorMessages.errorsArray) {
      const allMsg = errorMessages.errorsArray.map((e) => e.msg)
      return dispatch(setAlert(true, 'error', allMsg))
    }
    return dispatch(setAlert(true, 'error', errorMessages.message))
  }
}

export const refreshToken = (token) => async (dispatch) => {
  try {
    dispatch(verifyToken())
    const headers = {
      Authorization: `Bearer ${token}`,
    }
    const { data } = await api.refreshToken({ headers })
    dispatch({ type: SIGN_IN, payload: data })
    dispatch(setIsReady())
  } catch (error) {
    dispatch(setIsReady())
    localStorage.clear()
  }
}
